<template>
  <div class="page">
    <div class="back" @click="onClickLeft">
      <img src="@/assets/img/back.png" alt="">
    </div>
    <div class="main-content">
      <div class="title">请选择<span>维度</span></div>
      <div class="dimension-list">
        <div class="dimension-item" @click="selectDimension(item, index)" v-for="(item, index) in weidulist" :key="item.id">
          <div class="name-container">
            <span class="name">{{ item.main_name }}</span>
          </div>
          <div class="progress-bar">
            <div class="progress-bar-bg"></div>
            <div class="progress-bar-fill" :style="{ width: getProgressPercent(item.rec_num, item.topic_num) }"></div>
            <div class="progress-bar-point" :style="{ left: getProgressPercent(item.rec_num, item.topic_num) }"></div>
            <div class="progress-bar-text" :style="{ left: getProgressTextPosition(item.rec_num, item.topic_num) }">
              {{ getProgressPercent(item.rec_num, item.topic_num) }}
            </div>
          </div>
          <div class="status" v-if="item.status * 1 !== 0 && item.sys_status * 1 < 1">{{ ['','已评估','评估中'][item.status] }}</div>
        </div>
      </div>
      <div class="btn" @click="submit" :class="{over: over}">完成评估</div>
    </div>
    <van-popup class="scorebox" v-if="show" v-model="show" :close-on-click-overlay="false">
      <div class="container">
        <div class="calculatescore" v-for="item in scorearr" :key="item.id">
          <p :class="{ disabled: item.toprecord_id == 0 }" @click="backSee(item.topic_sort, item.toprecord_id)">{{item.name}}</p>
          <ul>
            <li :class="{ bgcolor: item.score === 0 || item.score === '0.0' }">0分</li>
            <li :class="{ bgcolor: item.score == 0.5 }">0.5分</li>
            <li :class="{ bgcolor: item.score == 1 }">1分</li>
          </ul>
        </div>
      </div>
      <div class="close-btn" @click="show = false">×</div>
    </van-popup>
    <van-popup class="stage" v-if="stageShow" v-model="stageShow" :close-on-click-overlay="false">
      <div class="container">
        <div class="header">请选择初始测评里程碑</div>
        <div class="content">
          <div class="stage-list">
            <div class="stage-list-item" v-for="(item, index) in stageList" :key="index">
              <div class="name">{{ item[0].sta_name }}（{{ ['','0-1','1-2','2-3','3-4','4-5','5-7'][item[0].sta_sort] }}岁）</div>
              <div class="milepost-list">
                <div class="milepost-list-item" :class="{ active: selectedMilepost.stageIndex * 1 === index && selectedMilepost.milepostInfo.mileage_id * 1 === item2.mileage_id * 1 }" v-for="item2 in item" :key="item2.mileage_id" @click="selectMilepost(index, item2)">{{ item2.ml_name }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="btn cancel" @click="stageCancel">取消</div>
          <div class="btn confirm" @click="stageOk">确定</div>
        </div>
      </div>
      <div class="close-btn" @click="stageShow = false">×</div>
    </van-popup>
  </div>
</template>
<script>
import { Notify, Toast, Dialog } from "vant";
import {
  settopicid,
  getuid,
  getreviewid,
  gettopicid,
  setltemname,
  settopic_num,
  setlesson_id,
  setnext,
} from "/src/api/userdata.js";
import { finish, rightscore, topicRecord, nextTopic, nextContent } from "../../api/index";
export default {
  data() {
    return {
      show: false,
      bgcolor: "bgcolor",
      weidulist: [],
      scorearr: [],
      over: false,
      iconlist: ["icon-motivation", "icon-attention", "icon-obedience", "icon-a-imitativeability", "icon-voice", "icon-a-grossaction", "icon-thinking", "icon-fine", "icon-a-Namingability", "icon-a-LanguageExchange", "icon-a-gameskills", "icon-a-academicskills", "icon-imagination", "icon-a-mentalcapacity", "icon-Life", "icon-a-collectiveskills", "icon-a-socialskills", "icon-motivation", "icon-attention", "icon-obedience", "icon-a-imitativeability", "icon-voice", "icon-a-grossaction", "icon-thinking", "icon-fine", "icon-a-Namingability", "icon-a-LanguageExchange", "icon-a-gameskills", "icon-a-academicskills", "icon-imagination", "icon-a-mentalcapacity", "icon-Life", "icon-a-collectiveskills", "icon-a-socialskills"],
      stageList: [],
      stageShow: false,
      selectedMilepost: {
        stageIndex: 0,
        milepostInfo: {}
      }
    };
  },
  created() {
    this.getlist().then(() => {
      const uid = getuid();
      const id = getreviewid();
      let arr = [] // 本次不需要评估且还未处理的维度
      this.weidulist.map(e => {
        if (e.status == 0 && e.rec_num >= e.topic_num && e.sys_status != 1) {
          arr.push({
            lesson_id: e.lesson_id,
            manor_id: e.manor_id,
            main_id: e.main_id,
          })
        }
      })
      if (!this.over && arr.length > 0) {
        this.weiduHandle(uid, id, arr)
      }
    });
  },
  methods: {
    async getlist() {
      const uid = getuid();
      const id = getreviewid();
      let pathArr = ['must-topic/main-list', 'must-topic/skill-list', 'must-topic/feel-list', 'must-topic/rim-list']
      let params = {
        uid,
        review_id: id
      }
      const res = await this.$http.get(pathArr[this.$route.query.eva_type], { params: params });
      if (res.code * 1 !== 1) {
        return this.$vantnotify(res.msg);
      }
      this.weidulist = res.data.list;
      this.over = res.data.is_ass == 2 ? true : false
    },
    // 处理本次不需要评估的维度
    async weiduHandle(uid, review_id, arr) {
      let params = {
        uid,
        review_id,
        ass_num: this.$route.query.ass_num,
        data: JSON.stringify(arr)
      }
      const res = await this.$http.post('must-topic/sys-finish', params);
      if (res.code * 1 !== 1) {
        return this.$vantnotify(res.msg);
      }
      this.getlist()
    },
    async selectDimension(item, index) {
      // setreviewid(item.id);
      settopicid(item.main_id);
      setltemname(item.main_name);
      settopic_num(item.topic_num);
      setlesson_id(item.lesson_id)
      setnext(index);
      const uid = getuid();
      const review_id = getreviewid();
      const main_id = gettopicid();
      if (this.weidulist[index].status == 1) {
        let params = {
          uid,
          review_id,
          main_id,
          type: 1
        }
        const res = await this.$http.get('must-trecord/trecord', { params: params });
        if (res.code * 1 !== 1) {
          return this.$vantnotify(res.msg);
        }
        this.scorearr = res.data instanceof Array ? res.data : [];
        this.show = true;
      } else {
        if (!item.m_status) {
          this.stageList = await this.getStageList(item.main_id)
          this.stageShow = true
        } else {
          let params = {
            uid: uid,
            review_id,
            main_id,
            topic_sort: 0
          }
          let res = await nextTopic(params)
          if (res.code == "9998") {
            Dialog.alert({
              title: "提示",
              message: res.msg,
              confirmButtonColor: "#fff",
              messageAlign: "left",
              getContainer: ".body",
            }).then(() => {
              this.getlist()
            });
          }
          if (res.code * 1 !== 1 && res.code * 1 !== 9998) {
            return Notify(res.msg);
          }
          let query = {
            ass_num: this.$route.query.ass_num,
            eva_type: this.$route.query.eva_type,
            is_rec: res.data.is_rec,
            trec_id: res.data.trec_id,
            topic_id: res.data.topic_id,
            topic_sort: res.data.is_rec ? res.data.topic_sort : ''
          }
          this.$router.push({ name: "topic", query });
        }
      }
    },
    async getStageList(main_id) {
      let params = {
        main_id
      }
      const res = await this.$http.get('must-topic/mile', { params: params });
      if (res.code * 1 !== 1) {
        return this.$vantnotify(res.msg);
      }
      return res.data instanceof Array ? res.data : [];
    },
    selectMilepost(stageIndex, milepostInfo) {
      this.$set(this.selectedMilepost, 'stageIndex', stageIndex);
      this.$set(this.selectedMilepost, 'milepostInfo', milepostInfo);
    },
    stageCancel() {
      this.stageShow = false;
      this.$set(this.selectedMilepost, 'stageIndex', 0);
      this.$set(this.selectedMilepost, 'milepostInfo', {});
    },
    async stageOk() {
      if (!this.selectedMilepost.milepostInfo.mileage_id) {
        return Notify({ type: 'danger', message: '请选择里程碑' });
      }
      // 选中里程碑后续跳转
      let query = {
        ass_num: this.$route.query.ass_num,
        eva_type: this.$route.query.eva_type,
        is_rec: 0,
        trec_id: 0,
        topic_id: this.selectedMilepost.milepostInfo.topic_id,
        topic_sort: '',
      }
      this.$router.push({ name: "topic", query });
      this.stageShow = false;
      this.$set(this.selectedMilepost, 'stageIndex', 0);
      this.$set(this.selectedMilepost, 'milepostInfo', {});
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    // 回看
    backSee(topic_sort, toprecord_id) {
      if (toprecord_id != 0) {
        let query = {
          topic_sort: topic_sort,
          not: 1,
          type: 0,
          eva_type: this.$route.query.eva_type,
        };
        this.$router.push({ name: "topic", query });
      }
    },
    submit() {
      if (this.over === true) {
        let uid = getuid();
        let review_id = getreviewid();
        let data = {
          uid,
          review_id,
          eva_type: this.$route.query.eva_type
        }
        finish(data).then((res) => {
          if (res.code == 1) {
            Toast.success({
              duration: 3000,
              forbidClick: true,
              message: "本次评估已完成",
              onClose: () => {
                this.$router.go(-1)
              },
            });
          } else {
            Notify(res.msg)
          }
        })
      } else {
        Toast.fail("评估未完成")
      }
    },
    getProgressPercent(rec_num, topic_num) {
      const percent = Math.round((rec_num / topic_num) * 100);
      return `${percent}%`;
    },
    getProgressTextPosition(rec_num, topic_num) {
      const percent = (rec_num / topic_num) * 100;
      if (percent < 10) {
        return '5%';
      }
      if (percent > 90) {
        return '90%';
      }
      return `${percent}%`;
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  min-height: 100vh;
  min-height: 100dvh;
  background: url("~@/assets/img/page-bg1.png") top left/100% 100% no-repeat;
  padding: 0.6rem 0.26rem 0.2rem;
  .back {
    position: absolute;
    left: 0.22rem;
    top: 0.3rem;
    font-size: 0;
    cursor: pointer;
    img {
      width: 0.26rem;
    }
  }
  button {
    border: none;
  }
  .van-nav-bar {
    background: none;
    &::after {
      border: none;
    }
    /deep/ .van-nav-bar__left {
      font-size: 0.14rem;
      .van-nav-bar__text {
        color: #666;
      }
      .van-icon {
        font-size: 0.14rem;
        color: #666;
        margin: 0;
      }
    }
  }

  .van-popup {
    background: linear-gradient(180deg, #f7bb94 0%, #f7ae9a 100%);
    border-radius: 0.16rem;
    padding: 0.1rem;
    overflow: unset;
    .container {
      background: linear-gradient(180deg, #ffdeb9 0%, #fff7ee 100%);
      box-shadow: 0 0 0.2rem 1px rgba(191, 41, 0, 0.62);
      border-radius: 0.14rem;
      padding-bottom: 0.2rem;
    }
    .close-btn {
      position: absolute;
      right: 0;
      top: 0;
      width: 0.2rem;
      height: 0.2rem;
      line-height: 0.2rem;
      text-align: center;
      background: linear-gradient(180deg, #ff8927 0%, #ff6238 100%);
      border: 1px solid #ffd98b;
      border-radius: 50%;
      color: #fff;
      font-size: 0.16rem;
      cursor: pointer;
    }
  }

  .main-content {
    padding: 0.4rem 0.16rem 0.4rem;
    background: url("~@/assets/img/dimension-list-bg.png") top left/100% 100%
      no-repeat;
    position: relative;
    .title {
      width: 2rem;
      height: 0.6rem;
      font-size: 0.16rem;
      font-weight: bold;
      color: #fff;
      background: url("~@/assets/img/dimension-title-bg.png") center/100% 100%
        no-repeat;
      text-align: center;
      position: absolute;
      top: -0.25rem;
      left: 50%;
      transform: translateX(-50%);
      padding-top: 0.1rem;
      span {
        font-size: 0.2rem;
        color: #ffe56f;
      }
    }
    .dimension-list {
      display: flex;
      flex-wrap: wrap;
      .dimension-item {
        width: 16.6%;
        height: 0.9rem;
        background: url("~@/assets/img/dimension-bg.png") center/100% 100%
          no-repeat;
        position: relative;
        cursor: pointer;
        overflow: hidden;
        padding: 0.26rem 0.2rem 0;
        .name-container {
          display: flex;
          align-items: center;
          .icon {
            font-size: 0.24rem;
            color: #d54e00;
            margin-right: 0.1rem;
          }
          .name {
            font-size: 0.12rem;
            color: #602600;
            font-weight: bold;
          }
        }
        .progress-bar {
          position: relative;
          margin-top: 0.24rem;
          .progress-bar-bg {
            width: 100%;
            height: 0.04rem;
            background: linear-gradient(180deg, #fff6e5 0%, #ffebd4 100%);
            box-shadow: inset 0 0 0.02rem 1px #ee7500;
            border-radius: 0.1rem;
          }
          .progress-bar-fill {
            height: 100%;
            background: linear-gradient(99deg, #ff8927 0%, #ff6238 100%);
            border-radius: 0.1rem;
            position: absolute;
            bottom: 0;
            left: 0;
          }
          .progress-bar-point {
            width: 0.06rem;
            height: 0.06rem;
            background: linear-gradient(180deg, #ff8927 0%, #ff6238 100%);
            box-shadow: 0 0 0.08rem 1px rgba(255, 0, 0, 0.8);
            border: 1px solid #ffe7aa;
            border-radius: 50%;
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
          }
          .progress-bar-text {
            position: absolute;
            top: -0.2rem;
            transform: translateX(-50%);
            text-align: center;
            font-size: 0.1rem;
            color: #bf6816;
            white-space: nowrap;
          }
        }
        .status {
          width: 0.46rem;
          height: 0.3rem;
          font-size: 0.1rem;
          color: #fff;
          text-align: center;
          line-height: 0.23rem;
          position: absolute;
          top: 0.045rem;
          right: 0.15rem;
          background: url("~@/assets/img/dimension-tag.png") center/100% 100%
            no-repeat;
        }
      }
    }
    .btn {
      width: 1rem;
      height: 0.36rem;
      background: url("~@/assets/img/cancel-btn1.png") center/100% 100%
        no-repeat;
      color: #979797;
      font-size: 0.14rem;
      font-weight: bold;
      text-align: center;
      line-height: 0.36rem;
      margin: 0.16rem auto 0;
      cursor: pointer;
      &.over {
        background: url("~@/assets/img/confirm-btn1.png") center/100% 100%
          no-repeat;
        color: #630200;
      }
    }
  }
  .scorebox {
    height: 80vh;
    .container {
      height: 100%;
      overflow-y: scroll;
      padding: 0.2rem;
    }
  }
  .calculatescore {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 0.12rem;
    &:last-child {
      margin-bottom: 0;
    }
    p {
      color: #ff6536;
      font-size: 0.14rem;
      margin: 0;
      min-width: 0.32rem;
      &.disabled {
        color: #999;
      }
    }
    ul {
      display: flex;
      li {
        width: 0.56rem;
        height: 0.3rem;
        background: linear-gradient(180deg, #fff6e5 0%, #ffebd4 100%);
        border-radius: 0.17rem;
        border: 1px solid #ffc763;
        font-size: 0.12rem;
        color: #630200;
        text-align: center;
        line-height: 0.3rem;
        margin-left: 0.16rem;
        &:first-child {
          margin-left: 0.1rem;
        }
      }
      li.bgcolor {
        background: linear-gradient(180deg, #ffe56f 0%, #ffd519 100%);
        border: 1px solid #ffbb00;
      }
    }
  }
  .stage {
    width: 4.6rem;
    .header {
      line-height: 0.6rem;
      font-size: 0.18rem;
      color: #d45500;
      text-align: center;
    }
    .content {
      padding: 0 0.24rem;
      .stage-list-item {
        display: flex;
        align-items: center;
        margin-bottom: 0.12rem;
        &:last-child {
          margin-bottom: 0;
        }
        .name {
          width: 1.2rem;
          font-size: 0.14rem;
          font-weight: bold;
          color: #630200;
          position: relative;
          top: -0.02rem;
        }
        .milepost-list {
          display: flex;
          align-items: center;
          flex: 1;
          &-item {
            width: 0.58rem;
            line-height: 0.28rem;
            background: linear-gradient(180deg, #fff6e5 0%, #ffebd4 100%);
            border-radius: 0.14rem;
            border: 0.01rem solid #ffc763;
            font-size: 0.12rem;
            color: #630200;
            margin-right: 0.12rem;
            text-align: center;
            &:last-child {
              margin-right: 0;
            }
            &.active {
              background: linear-gradient(180deg, #ffe56f 0%, #ffd519 100%);
              border: 1px solid #ffbb00;
            }
          }
        }
      }
    }
    .footer {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0.2rem;
      .btn {
        width: 0.76rem;
        height: 0.3rem;
        line-height: 0.3rem;
        font-size: 0.14rem;
        margin: 0 0.07rem;
        text-align: center;
        &.cancel {
          background: url("~@/assets/img/cancel-btn2.png") center/100% 100%
            no-repeat;
          color: #630200;
        }
        &.confirm {
          background: url("~@/assets/img/confirm-btn2.png") center/100% 100%
            no-repeat;
          color: #fff;
        }
      }
    }
  }
}
</style>
